module.exports = __webpack_public_path__ + "static/media/ButtonArrow.b388e64a.svg";